import React from 'react'

import { H1 } from '@mxenabled/mxui'

import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded'
import ListIcon from '@mui/icons-material/List'
import { Box, Button, Stack, Tab, Tabs, ToggleButton, ToggleButtonGroup } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'

import { useCopy, useCustomInsights } from '../../context/RulesEngineDataProvider'
import { CustomInsightStatus } from '../../types/CustomInsight'
import { Table } from '../TableView/Table'

import { InsightCard } from './InsightCard'



enum Views {
  grid = 'GRID',
  list = 'LIST',
}

export const InsightCardsPage = () => {
  const copy = useCopy()
  const customInsights = useCustomInsights()

  const [layoutView, setLayoutView] = React.useState(Views.grid)
  const [activeTab, setActiveTab] = React.useState(0)
  const [filteredInsights, setFilteredInsights] = React.useState(customInsights)

  const changeLayout = (_: React.MouseEvent, newLayout: Views) => {
    if (newLayout !== null) {
      setLayoutView(newLayout)
    }
  }

  const changeTab = (_: React.SyntheticEvent, newTab: CustomInsightStatus) => {
    if (newTab === 0) {
      setFilteredInsights(customInsights)
    } else if (newTab === 1) {
      setFilteredInsights(
        customInsights.filter((insight) => insight.status === CustomInsightStatus.Active),
      )
    } else if (newTab === 2) {
      setFilteredInsights(
        customInsights.filter((insight) => insight.status === CustomInsightStatus.Pending),
      )
    } else {
      setFilteredInsights(
        customInsights.filter((insight) => insight.status === CustomInsightStatus.Disabled),
      )
    }

    setActiveTab(newTab)
  }

  return (
    <Stack sx={{ px: 48, pt: 32 }}>
      <Box sx={{ maxWidth: 1176, alignContent: 'center', mx: 'auto', width: '100%' }}>
        {/* Header with title and controls */}
        <Box
          sx={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between', mb: 12 }}
        >
          <H1>{copy.custom_insights_title}</H1>
          <Box sx={{ display: 'flex', gap: 32, justifyContent: 'center' }}>
            <ToggleButtonGroup exclusive={true} onChange={changeLayout} value={layoutView}>
              <ToggleButton size="small" value={Views.grid}>
                <GridViewRoundedIcon color={layoutView === Views.grid ? 'primary' : 'secondary'} />
              </ToggleButton>
              <ToggleButton size="small" value={Views.list}>
                <ListIcon color={layoutView === Views.list ? 'primary' : 'secondary'} />
              </ToggleButton>
            </ToggleButtonGroup>
            {/* TODO hook up button */}
            <Button onClick={() => {}} variant="contained">
              {copy.create_insight_button}
            </Button>
          </Box>
        </Box>

        {/* Tabs */}
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 32 }}>
          <Tabs onChange={changeTab} value={activeTab}>
            <Tab label={copy.all_tab} />
            <Tab label={copy.active_tab} />
            <Tab label={copy.pending_tab} />
            <Tab label={copy.disabled_tab} />
          </Tabs>
        </Box>

        {/* Content */}
        {layoutView === Views.grid ? (
          <Grid columnSpacing={32} container={true} rowSpacing={32}>
            {filteredInsights.map((insight, index) => (
              <Grid key={index} lg={3} md={4} sm={6} xs={12}>
                <InsightCard insight={insight} />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Table copy={copy} insights={filteredInsights} />
        )}
      </Box>
    </Stack>
  )
}
export { CustomInsightStatus }
